import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { AppBar, Box, Toolbar, IconButton, Divider } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import { styled, useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';

import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Menu from '/components/layouts/Menu';
import Logo from '/components/layouts/Logo';
import Bluebttn from '/components/layouts/Bluebttn';
import Home from '/public/home/home_w.svg';

// utils
import useWindowSize from '/utils/useWindowSize';
import PosterImg from '/public/home/poster.png';
import PosterSvg from '/public/home/poster.svg';

const useStyles = makeStyles({
    root: {
        backgroundColor: '#FFFFFF',
        // justifyContent: 'flex-end',
        alignItems: 'center',
        // boxShadow: 'none',
        boxShadow: '2px 2px 4px 1px rgba(166, 166, 166, 0.35)',
        height: 120,
    },
    toolbar: {
        width: '88%',
        display: 'flex',
        justifyContent: 'space-between',
        // '& .MuiButtonBase-root.MuiIconButton-edgeStart ': {
        //     border: '1px solid #e1e1e1',
        //     borderRadius: '9px',
        // },
    },
    logoBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: 86,
    },
    menuBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: '100%',
        height: 36,
        // margin: '10px 0px 10px 0px'
    },
    menus: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: '100%',
    },
    menu: {
        padding: '25px 0px 0px 20px',
        fontSize: '14px',
        fontFamily: ' Roboto',
        cursor: 'pointer',
        justifyContent: 'start',
        '&:hover': {
            backgroundColor: '#87B0ED',
            cursor: 'pointer',
        },
    },
    divider: {
        backgroundColor: '#C1C3FC',
        height: 1,
        width: '100%',
    },
    popper: {
        '& .MuiPaper-root': {
            backgroundColor: '#F3F3F3',
            '& .MuiButtonBase-root': {
                minHeight: 38,
            },
        },
    },
    poster: {
        marginTop: 120,
    },
});

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

const TopBar = ({ className, onMobileNavOpen, menus, ...rest }) => {
    const classes = useStyles();
    const theme = useTheme();
    const router = useRouter();

    const { width } = useWindowSize();
    const [open, setOpen] = useState(false);
    const [tacrimImg, setTacrimImg] = useState(false);
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (!router.isReady) return; // Router бүрэн ачаалсны дараа үргэлжлүүлнэ
        if (Object.hasOwn(router.query, 'tacrim')) {
            setTacrimImg(true);
        } else {
            setTacrimImg(false);
        }
    }, [router.isReady, router.query]);

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         setSize({ width: window.innerWidth, height: window.innerHeight });

    //         const handleResize = () => {
    //             setSize({ width: window.innerWidth, height: window.innerHeight });
    //         };

    //         window.addEventListener('resize', handleResize);
    //         return () => window.removeEventListener('resize', handleResize);
    //     }
    // }, []);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CssBaseline />
            <AppBar className={clsx(classes.root, className)} {...rest}>
                <Toolbar
                    className={classes.toolbar}
                    // style={{ width: width > 600 ? '85%' : '100%' }}
                    key={Math.random()}
                >
                    <Box className={classes.logoBox}>
                        <Logo textcolor="#2E3192" position="header" />
                        {width > 700 ? <Bluebttn windowsize={width} type="header" /> : ''}
                    </Box>
                </Toolbar>
                <Divider className={classes.divider} />
                {/* <pre>{JSON.stringify(size, null, 2)}</pre>
                <pre>{width}</pre> */}

                <Toolbar
                    className={classes.toolbar}
                    style={{ minHeight: 36, height: 36 }}
                    key={Math.random()}
                >
                    {width > 700 ? (
                        <Box my={2} className={classes.menuBox}>
                            <div style={{ cursor: 'pointer' }}>
                                <Link legacyBehavior href="/home">
                                    <Image
                                        src={Home}
                                        width={20}
                                        height={16}
                                        alt="logo image"
                                        priority
                                        fetchpriority="high"
                                    />
                                </Link>
                            </div>
                            <Box className={classes.menus}>
                                {menus &&
                                    menus.map((menu) => {
                                        return (
                                            <Menu
                                                // key={Math.floor(Math.random() * 100 + menu.id)}
                                                key={
                                                    menu.id
                                                        ? `item-${menu.id}`
                                                        : `fallback-${Math.random()}`
                                                }
                                                menu={menu}
                                            />
                                        );
                                    })}
                            </Box>
                        </Box>
                    ) : (
                        <>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                sx={{ mr: 2, ...(open && { display: 'none' }) }}
                            >
                                <MenuIcon />
                            </IconButton>
                        </>
                    )}
                </Toolbar>
            </AppBar>
            {tacrimImg == true && (
                <Box className={classes.poster}>
                    <Image
                        loader={() => PosterSvg}
                        src={PosterSvg}
                        // width={800}
                        // height={160}
                        quality={90}
                        layout="responsive"
                        objectFit="cover"
                        alt="TACRIM MONGOLIA"
                        unoptimized
                        fetchpriority="high"
                        priority
                    />
                </Box>
            )}
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List>
                    <Box>
                        {menus &&
                            menus.map((menu) => {
                                return (
                                    <Menu
                                        key={Math.floor(Math.random() * 100 + menu.id)}
                                        menu={menu}
                                        classNames={classes.menu}
                                        popperClass={classes.popper}
                                    />
                                );
                            })}
                    </Box>
                </List>
            </Drawer>
        </Box>
    );
};

TopBar.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func,
    menus: PropTypes.array,
};

// TopBar.defaultProps = {
//     menus: [],
// };

export default TopBar;
